"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MusicCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_core_ui_1 = __importStar(require("@snapchat/web-core-ui"));
const BaseInThisSnapCard_1 = require("../BaseInThisSnapCard");
const MusicCard_module_css_1 = __importDefault(require("./MusicCard.module.css"));
function MusicIcon(iconUrl, fallbackSVG) {
    return ((0, jsx_runtime_1.jsx)("div", { className: MusicCard_module_css_1.default.musicIcon, children: iconUrl ? ((0, jsx_runtime_1.jsx)(web_core_ui_1.WebPImage, { webpUrl: iconUrl, fallbackUrl: fallbackSVG, imgProps: {
                // TODO: Localize alt text
                alt: "Music Thumbnail",
            } })) : ((0, jsx_runtime_1.jsx)(web_core_ui_1.SoundIcon, {})) }));
}
/**
 * Component to information about the Music in a Snap.
 */
function MusicCard({ metadata }) {
    return ((0, jsx_runtime_1.jsx)(BaseInThisSnapCard_1.BaseInThisSnapCard, { title: metadata.songName, subtitle: metadata.artistName, iconUrl: metadata.iconUrl, customIconClassName: MusicCard_module_css_1.default.musicIcon, 
        // @ts-ignore
        overrideIcon: MusicIcon(metadata.iconUrl, web_core_ui_1.default) }));
}
exports.MusicCard = MusicCard;
//# sourceMappingURL=MusicCard.js.map